import styled from "styled-components";


export const BulkTaggingContainer = styled.div`

  .AddNewTag_container {
    min-height: auto;
  }
`